import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { ApiHandler } from "@insite/client-framework/HandlerCreator";
import { Session } from "@insite/client-framework/Services/SessionService";
import { chain, DispatchCompleteSignIn } from "@insite/client-framework/Store/Context/Handlers/SignIn";

type HandlerType = ApiHandler<
    SignInParameter,
    SignInResult,
    {
        tokenSuccessfullyRequested?: boolean;
        authenticatedSession?: Session;
    }
>;

export interface SignInParameter {
    userName: string;
    password: string;
    rememberMe: boolean;
    returnUrl?: string | undefined;
    onError?: (error: string, statusCode?: number) => void;
}

export interface SignInResult {
    readonly access_token: string;
    readonly refresh_token: string;
    readonly expires_in: number;
    readonly error_description: string;
}

export const NavigateToExternalReturnUrl: HandlerType = props => {
    if (props.parameter.returnUrl?.includes("https://") && props.tokenSuccessfullyRequested) {
        window.location.replace(props.parameter.returnUrl);
        return false;
    }
};

addToChainAfter(chain, DispatchCompleteSignIn, NavigateToExternalReturnUrl);
